import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import helpIcon from './i/help.png'
import youtubeIcon from './i/youtube.svg'
import backIcon from './i/back.svg'

import styles from './Description.module.scss'

const Description = ({ title, subTitle, width = 300, isAddContacts, isCentered, onBack, className }) => {
    const { t } = useTranslation()

    return (
        <div
            className={classNames(styles.description, {
                [className]: !!className,
                [styles.isCenteredDescription]: isCentered,
            })}
            style={{ width }}
        >
            {title && <h2 className={styles.title}>{title}</h2>}
            {subTitle && <h3 className={styles.subTitle}>{subTitle}</h3>}
            {isAddContacts && (
                <ul className={styles.contactsList}>
                    <li className={styles.contact}>
                        <div className={styles.contactIconBox}>
                            <img className={styles.contactIcon} src={helpIcon} alt="help" />
                        </div>
                        <a className={styles.contactLink} target="_blank" href="https://help.interacty.me/">
                            {t('Visit our Help Center')}
                        </a>
                    </li>
                    <li className={styles.contact}>
                        <div className={styles.contactIconBox}>
                            <img className={styles.contactIcon} src={youtubeIcon} alt="help" />
                        </div>
                        <a className={styles.contactLink} target="_blank" href="https://www.youtube.com/@Interacty">
                            {t('Subscribe to our YouTube channel')}
                        </a>
                    </li>
                </ul>
            )}
            {!!onBack && (
                <div className={styles.back} onClick={onBack}>
                    <img src={backIcon} alt="back" />
                    {t('Back')}
                </div>
            )}
        </div>
    )
}

export default Description
